interface TranslationType {
  en: string,
  fr: string
}

interface TranslationsType {
  [propName: string]: TranslationType;
}

export default <TranslationsType> {
  unableToComputePriceQualifierTitle: {
    en: 'This price cannot be qualified',
    fr: 'Ce prix est non qualifiable'
  },
  notEnoughDataPriceQualifierTitle: {
    en: 'This price cannot be qualified',
    fr: 'Ce prix est non qualifiable'
  },
  badPriceQualifierTitle: {
    en: 'This is pricey',
    fr: 'Ce prix est cher'
  },
  averagePriceQualifierTitle: {
    en: 'This price is neither good nor bad',
    fr: 'Ce prix est couci-couça'
  },
  goodPriceQualifierTitle: {
    en: 'This is a bargain!',
    fr: 'Ce prix est avantageux !'
  },
  greatPriceQualifierTitle: {
    en: 'This is a great bargain!',
    fr: 'Ce prix est très avantageux !'
  },
  defaultPriceQualifierTitle: {
    en: 'This price cannot be qualified',
    fr: 'Ce prix est non qualifiable'
  },
  unableToComputePriceQualifierMsg: {
    en: 'This price cannot be qualified because the information provided by the merchant is incomplete.',
    fr: 'Ce prix ne peut être qualifié, parce-que les informations fournies par le marchand sont incomplètes'
  },
  notEnoughDataPriceQualifierMsg: {
    en: 'Insufficient data to determine if the price is good or bad.',
    fr: 'Ce prix ne peut être qualifié, parce-que  l\'historique de prix est insuffisant'
  },
  badPriceQualifierMsg: {
    en: 'This product is usually cheaper at this time of year in your region. Buy if quality is worth it or if really needed.',
    fr: 'Ce produit est souvent moins cher à ce moment de l\'année dans votre région. Achetez-le si la qualité le justifie ou si vous en avez vraiment besoin.'
  },
  averagePriceQualifierMsg: {
    en: 'The price is about average for this time of year in your region.',
    fr: 'Ce prix est dans la moyenne pour ce moment de l\'année dans votre région.'
  },
  goodPriceQualifierMsg: {
    en: 'This product is rarely cheaper at this time of year in your region. Stock up!',
    fr: 'Ce produit est rarement moins cher à ce moment de l\'année dans votre région. Profitez-en!'
  },
  greatPriceQualifierMsg: {
    en: 'This product is very rarely cheaper at this time of year in your region. Stock up!',
    fr: 'Ce produit n\'est presque jamais moins cher à ce moment de l\'année dans votre région. Profitez-en!'
  },
  defaultPriceQualifierMsg: {
    en: 'This price cannot be qualified',
    fr: 'Ce prix ne peut être qualifié'
  },
  homePageTitle: {
    en: 'Grocery Price Checker',
    fr: 'Évaluateur de prix en épicerie'
  },
  itemName: {
    en: 'Item name',
    fr: 'Nom de l\'article'
  },
  itemNameExample: {
    en: 'e.g. mushrooms, button',
    fr: 'ex : champignons de Paris'
  },
  quantityLabel: {
    en: 'Quantity',
    fr: 'Quantité'
  },
  priceLabel: {
    en: 'Price ($)',
    fr: 'Prix ($)'
  },
  checkPrice: {
    en: 'Check',
    fr: 'Évaluer'
  },
  reset: {
    en: 'Reset',
    fr: 'Recommencer'
  },
  cancel: {
    en: 'Cancel',
    fr: 'Annuler'
  },
  ok: {
    en: 'ok',
    fr: 'ok'
  },
  unitLabel: {
    en: 'Selling format',
    fr: 'Format de vente'
  },
  unitInternalLabel: {
    en: 'The item is sold by:',
    fr: 'L\'article est vendu à/au :'
  },
  sizeLabel: {
    en: 'Size (if mentioned)',
    fr: 'Grosseur (si indiquée)'
  },
  soscLogo: {
    en: 'Logo of SOS Cuisine',
    fr: 'Logo de SOS Cuisine'
  },
  provincialFlag: {
    en: 'Provincial flag',
    fr: 'Drapeau provincial'
  },
  foxFamily: {
    en: 'Fox family',
    fr: 'Famille de renards'
  },
  offlineMsg: {
    en: 'This app requires an internet connection to access the price database. Please connect.',
    fr: 'Cette application requiert une connexion internet pour faire l\'évaluation en temps réel. Veuillez vous connecter.'
  },
  discoverPlus: {
    en: 'Discover our PLUS plan',
    fr: 'Découvrir l\'offre PLUS'
  },
  install: {
    en: 'Install the mobile app',
    fr: 'Installez l\'appli mobile'
  },
  installation: {
    en: 'Installation',
    fr: 'Installation'
  },
  installationFirstStep: {
    en: 'Step 1: Click on',
    fr: 'Étape 1 : Cliquez sur'
  },
  installationSecondStepIOS: {
    en: 'Step 2 : Click on "Add to Home Screen"',
    fr: 'Étape 2 : Cliquez sur «Ajouter à l\'écran d\'accueil»'
  },
  installationThirdStepIOS: {
    en: 'Step 3 : Click on "Add"',
    fr: 'Étape 3 : Cliquez sur «Ajouter»'
  },
  installationSecondStepAndroid: {
    en: 'Step 2 : Click on "Add SOS EPE to Home screen" or "Install App"',
    fr: 'Étape 2 : Cliquez sur «Ajouter SOS EPE à l\'écran d\'accueil» ou «Installer l\'application»'
  },
  topRightCorner: {
    en: 'in the top right corner of your browser',
    fr: 'en haut à droite de votre navigateur'
  },
  backToWeb: {
    en: 'Back to website',
    fr: 'Retourner au site'
  }
};
